import { AuthContext as e, AuthorizedApiBase as t } from "@urbanx/agx.auth.client";
import n from "axios";
import { c as r } from "react/compiler-runtime";
import { jsx as i } from "react/jsx-runtime";
import { createContext as a, useContext as o, useEffect as s, useState as c } from "react";
import { useMutation as l, useQuery as u, useQueryClient as d } from "@tanstack/react-query";
//#region src/Client.ts
function f(e) {
	return e instanceof Date ? e.toISOString() : String(e);
}
var p = class extends t {
	instance;
	baseUrl;
	jsonParseReviver;
	constructor(e, t) {
		super(), this.instance = t ?? n.create(), this.baseUrl = e ?? "http://127.0.0.1:7092/Proposals";
	}
	agentListFontResources(e) {
		let t = this.baseUrl + "/AgentListFontResources", r = {
			method: "GET",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processAgentListFontResources(e)));
	}
	processAgentListFontResources(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 401 || e.status === 403 ? U("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : U("An unexpected server error occurred.", e.status, e.data, t);
	}
	archiveProposal(e, t) {
		let r = this.baseUrl + "/ArchiveProposal", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processArchiveProposal(e)));
	}
	processArchiveProposal(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? U("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 401 ? U("No description", e.status, e.data, t) : e.status === 404 || e.status === 409 ? U("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : U("An unexpected server error occurred.", e.status, e.data, t);
	}
	createPrivateSectionTemplate(e, t) {
		let r = this.baseUrl + "/CreatePrivateSectionTemplate", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processCreatePrivateSectionTemplate(e)));
	}
	processCreatePrivateSectionTemplate(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? U("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 401 ? U("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : U("An unexpected server error occurred.", e.status, e.data, t);
	}
	createProposal(e, t) {
		let r = this.baseUrl + "/CreateProposal", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processCreateProposal(e)));
	}
	processCreateProposal(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? U("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 401 ? U("No description", e.status, e.data, t) : e.status === 404 || e.status === 409 ? U("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : U("An unexpected server error occurred.", e.status, e.data, t);
	}
	deleteProposal(e, t) {
		let r = this.baseUrl + "/DeleteProposal", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processDeleteProposal(e)));
	}
	processDeleteProposal(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? U("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 401 ? U("No description", e.status, e.data, t) : e.status === 404 || e.status === 409 ? U("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : U("An unexpected server error occurred.", e.status, e.data, t);
	}
	duplicateProposal(e, t) {
		let r = this.baseUrl + "/DuplicateProposal", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processDuplicateProposal(e)));
	}
	processDuplicateProposal(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? U("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 401 ? U("No description", e.status, e.data, t) : e.status === 404 ? U("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : U("An unexpected server error occurred.", e.status, e.data, t);
	}
	getProposal(e, t) {
		let r = this.baseUrl + "/GetProposal";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'proposalId' must be defined and cannot be null.");
		r += "proposalId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetProposal(e)));
	}
	processGetProposal(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 401 ? U("No description", e.status, e.data, t) : e.status === 404 ? U("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : U("An unexpected server error occurred.", e.status, e.data, t);
	}
	getRenderContext(e, t) {
		let r = this.baseUrl + "/GetRenderContext";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'proposalId' must be defined and cannot be null.");
		r += "proposalId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetRenderContext(e)));
	}
	processGetRenderContext(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? U("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 401 || e.status === 403 ? U("No description", e.status, e.data, t) : e.status === 404 ? U("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : U("An unexpected server error occurred.", e.status, e.data, t);
	}
	insertPublishedSectionTemplate(e, t) {
		let r = this.baseUrl + "/InsertPublishedSectionTemplate", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processInsertPublishedSectionTemplate(e)));
	}
	processInsertPublishedSectionTemplate(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? U("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 401 ? U("No description", e.status, e.data, t) : e.status === 404 || e.status === 409 ? U("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : U("An unexpected server error occurred.", e.status, e.data, t);
	}
	listProposals(e, t, r) {
		let i = this.baseUrl + "/ListProposals";
		if (i += "?", e === null) throw new globalThis.Error("The parameter 'agencyIds' cannot be null.");
		if (e !== void 0) for (let t of e) i += "agencyIds=" + encodeURIComponent(f(t)) + "&";
		if (t === null) throw new globalThis.Error("The parameter 'campaignId' cannot be null.");
		t !== void 0 && (i += "campaignId=" + encodeURIComponent(f(t)) + "&"), i = i.replace(/[?&]$/, "");
		let a = {
			method: "GET",
			url: i,
			headers: { Accept: "application/json" },
			signal: r
		};
		return this.transformOptions(a).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processListProposals(e)));
	}
	processListProposals(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? U("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : U("An unexpected server error occurred.", e.status, e.data, t);
	}
	listPublishedProposalTemplates(e, t, r, i) {
		let a = this.baseUrl + "/ListPublishedProposalTemplates";
		if (a += "?", e == null) throw new globalThis.Error("The parameter 'subjectType' must be defined and cannot be null.");
		a += "subjectType=" + encodeURIComponent(f(e)) + "&", t != null && (a += "hasAddress=" + encodeURIComponent(f(t)) + "&"), r != null && (a += "hasJurisdiction=" + encodeURIComponent(f(r)) + "&"), a = a.replace(/[?&]$/, "");
		let o = {
			method: "GET",
			url: a,
			headers: { Accept: "application/json" },
			signal: i
		};
		return this.transformOptions(o).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(a, e, (e) => this.processListPublishedProposalTemplates(e)));
	}
	processListPublishedProposalTemplates(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? U("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 401 ? U("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : U("An unexpected server error occurred.", e.status, e.data, t);
	}
	listSectionTemplates(e, t, r, i, a) {
		let o = this.baseUrl + "/ListSectionTemplates";
		if (o += "?", e === null) throw new globalThis.Error("The parameter 'status' cannot be null.");
		if (e !== void 0 && (o += "status=" + encodeURIComponent(f(e)) + "&"), t === null) throw new globalThis.Error("The parameter 'scope' cannot be null.");
		if (t !== void 0 && (o += "scope=" + encodeURIComponent(f(t)) + "&"), r === null) throw new globalThis.Error("The parameter 'agencyId' cannot be null.");
		if (r !== void 0 && (o += "agencyId=" + encodeURIComponent(f(r)) + "&"), i === null) throw new globalThis.Error("The parameter 'publishedOnly' cannot be null.");
		i !== void 0 && (o += "publishedOnly=" + encodeURIComponent(f(i)) + "&"), o = o.replace(/[?&]$/, "");
		let s = {
			method: "GET",
			url: o,
			headers: { Accept: "application/json" },
			signal: a
		};
		return this.transformOptions(s).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(o, e, (e) => this.processListSectionTemplates(e)));
	}
	processListSectionTemplates(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? U("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 401 ? U("No description", e.status, e.data, t) : e.status === 403 ? U("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : U("An unexpected server error occurred.", e.status, e.data, t);
	}
	saveProposal(e, t) {
		let r = this.baseUrl + "/SaveProposal", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processSaveProposal(e)));
	}
	processSaveProposal(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? U("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 401 ? U("No description", e.status, e.data, t) : e.status === 404 || e.status === 409 ? U("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : U("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffArchiveProposalTemplate(e, t, r) {
		let i = this.baseUrl + "/StaffArchiveProposalTemplate";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'templateId' must be defined and cannot be null.");
		i += "templateId=" + encodeURIComponent(f(e)) + "&", i = i.replace(/[?&]$/, "");
		let a = JSON.stringify(t), o = {
			method: "POST",
			url: i,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: a,
			signal: r
		};
		return this.transformOptions(o).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processStaffArchiveProposalTemplate(e)));
	}
	processStaffArchiveProposalTemplate(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 401 ? U("No description", e.status, e.data, t) : e.status === 403 || e.status === 404 || e.status === 409 ? U("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : U("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffArchiveSectionTemplate(e, t) {
		let r = this.baseUrl + "/StaffArchiveSectionTemplate", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffArchiveSectionTemplate(e)));
	}
	processStaffArchiveSectionTemplate(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? U("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 401 ? U("No description", e.status, e.data, t) : e.status === 403 || e.status === 404 || e.status === 409 ? U("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : U("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffArchiveThemeSet(e, t, r) {
		let i = this.baseUrl + "/StaffArchiveThemeSet";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'id' must be defined and cannot be null.");
		i += "id=" + encodeURIComponent(f(e)) + "&", i = i.replace(/[?&]$/, "");
		let a = JSON.stringify(t), o = {
			method: "POST",
			url: i,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: a,
			signal: r
		};
		return this.transformOptions(o).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processStaffArchiveThemeSet(e)));
	}
	processStaffArchiveThemeSet(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 401 ? U("No description", e.status, e.data, t) : e.status === 403 || e.status === 404 || e.status === 409 ? U("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : U("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffCreateProposalTemplate(e, t) {
		let r = this.baseUrl + "/StaffCreateProposalTemplate", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffCreateProposalTemplate(e)));
	}
	processStaffCreateProposalTemplate(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? U("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 401 ? U("No description", e.status, e.data, t) : e.status === 403 || e.status === 409 ? U("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : U("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffCreateSectionTemplate(e, t) {
		let r = this.baseUrl + "/StaffCreateSectionTemplate", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffCreateSectionTemplate(e)));
	}
	processStaffCreateSectionTemplate(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? U("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 401 ? U("No description", e.status, e.data, t) : e.status === 403 || e.status === 404 || e.status === 409 ? U("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : U("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffCreateThemeSet(e, t) {
		let r = this.baseUrl + "/StaffCreateThemeSet", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffCreateThemeSet(e)));
	}
	processStaffCreateThemeSet(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? U("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 401 ? U("No description", e.status, e.data, t) : e.status === 403 ? U("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : U("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffDuplicateProposalTemplate(e, t) {
		let r = this.baseUrl + "/StaffDuplicateProposalTemplate", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffDuplicateProposalTemplate(e)));
	}
	processStaffDuplicateProposalTemplate(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? U("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 401 ? U("No description", e.status, e.data, t) : e.status === 403 || e.status === 404 || e.status === 409 ? U("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : U("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffDuplicateThemeSet(e, t, r) {
		let i = this.baseUrl + "/StaffDuplicateThemeSet";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'id' must be defined and cannot be null.");
		i += "id=" + encodeURIComponent(f(e)) + "&", i = i.replace(/[?&]$/, "");
		let a = JSON.stringify(t), o = {
			method: "POST",
			url: i,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: a,
			signal: r
		};
		return this.transformOptions(o).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processStaffDuplicateThemeSet(e)));
	}
	processStaffDuplicateThemeSet(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? U("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 401 ? U("No description", e.status, e.data, t) : e.status === 403 || e.status === 404 || e.status === 409 ? U("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : U("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffListFonts(e, t) {
		let r = this.baseUrl + "/StaffListFonts";
		if (r += "?", e === null) throw new globalThis.Error("The parameter 'agencyId' cannot be null.");
		e !== void 0 && (r += "agencyId=" + encodeURIComponent(f(e)) + "&"), r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffListFonts(e)));
	}
	processStaffListFonts(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 401 ? U("No description", e.status, e.data, t) : e.status === 403 ? U("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : U("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffListProposalTemplates(e, t, r, i) {
		let a = this.baseUrl + "/StaffListProposalTemplates";
		if (a += "?", e === null) throw new globalThis.Error("The parameter 'status' cannot be null.");
		if (e !== void 0 && (a += "status=" + encodeURIComponent(f(e)) + "&"), t === null) throw new globalThis.Error("The parameter 'agencyId' cannot be null.");
		if (t !== void 0 && (a += "agencyId=" + encodeURIComponent(f(t)) + "&"), r === null) throw new globalThis.Error("The parameter 'search' cannot be null.");
		r !== void 0 && (a += "search=" + encodeURIComponent(f(r)) + "&"), a = a.replace(/[?&]$/, "");
		let o = {
			method: "GET",
			url: a,
			headers: { Accept: "application/json" },
			signal: i
		};
		return this.transformOptions(o).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(a, e, (e) => this.processStaffListProposalTemplates(e)));
	}
	processStaffListProposalTemplates(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? U("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 401 ? U("No description", e.status, e.data, t) : e.status === 403 ? U("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : U("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffListThemeSets(e, t, r) {
		let i = this.baseUrl + "/StaffListThemeSets";
		if (i += "?", e === null) throw new globalThis.Error("The parameter 'includeArchived' cannot be null.");
		if (e !== void 0 && (i += "includeArchived=" + encodeURIComponent(f(e)) + "&"), t === null) throw new globalThis.Error("The parameter 'agencyId' cannot be null.");
		t !== void 0 && (i += "agencyId=" + encodeURIComponent(f(t)) + "&"), i = i.replace(/[?&]$/, "");
		let a = {
			method: "GET",
			url: i,
			headers: { Accept: "application/json" },
			signal: r
		};
		return this.transformOptions(a).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processStaffListThemeSets(e)));
	}
	processStaffListThemeSets(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 401 ? U("No description", e.status, e.data, t) : e.status === 403 ? U("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : U("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffPublishProposalTemplate(e, t, r) {
		let i = this.baseUrl + "/StaffPublishProposalTemplate";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'templateId' must be defined and cannot be null.");
		i += "templateId=" + encodeURIComponent(f(e)) + "&", i = i.replace(/[?&]$/, "");
		let a = JSON.stringify(t), o = {
			method: "POST",
			url: i,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: a,
			signal: r
		};
		return this.transformOptions(o).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processStaffPublishProposalTemplate(e)));
	}
	processStaffPublishProposalTemplate(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? U("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 401 ? U("No description", e.status, e.data, t) : e.status === 403 || e.status === 404 || e.status === 409 ? U("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : U("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffPublishSectionTemplate(e, t) {
		let r = this.baseUrl + "/StaffPublishSectionTemplate", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffPublishSectionTemplate(e)));
	}
	processStaffPublishSectionTemplate(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? U("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 401 ? U("No description", e.status, e.data, t) : e.status === 403 || e.status === 404 || e.status === 409 ? U("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : U("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffUpdateProposalTemplate(e, t, r) {
		let i = this.baseUrl + "/StaffUpdateProposalTemplate";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'templateId' must be defined and cannot be null.");
		i += "templateId=" + encodeURIComponent(f(e)) + "&", i = i.replace(/[?&]$/, "");
		let a = JSON.stringify(t), o = {
			method: "PUT",
			url: i,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: a,
			signal: r
		};
		return this.transformOptions(o).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processStaffUpdateProposalTemplate(e)));
	}
	processStaffUpdateProposalTemplate(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? U("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 401 ? U("No description", e.status, e.data, t) : e.status === 403 || e.status === 404 || e.status === 409 ? U("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : U("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffUpdateSectionTemplate(e, t) {
		let r = this.baseUrl + "/StaffUpdateSectionTemplate", i = {
			method: "PUT",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffUpdateSectionTemplate(e)));
	}
	processStaffUpdateSectionTemplate(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? U("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 401 ? U("No description", e.status, e.data, t) : e.status === 403 || e.status === 404 || e.status === 409 ? U("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : U("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffUpdateThemeSet(e, t, r) {
		let i = this.baseUrl + "/StaffUpdateThemeSet";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'id' must be defined and cannot be null.");
		i += "id=" + encodeURIComponent(f(e)) + "&", i = i.replace(/[?&]$/, "");
		let a = JSON.stringify(t), o = {
			method: "PUT",
			url: i,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: a,
			signal: r
		};
		return this.transformOptions(o).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processStaffUpdateThemeSet(e)));
	}
	processStaffUpdateThemeSet(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? U("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 401 ? U("No description", e.status, e.data, t) : e.status === 403 || e.status === 404 || e.status === 409 ? U("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : U("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffUploadFont(e, t) {
		let r = this.baseUrl + "/StaffUploadFont", i = new FormData();
		for (let [t, n] of Object.entries(e ?? {})) n != null && i.append(t, n instanceof Blob ? n : String(n));
		let a = {
			method: "POST",
			url: r,
			headers: { Accept: "application/json" },
			data: i,
			signal: t
		};
		return this.transformOptions(a).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffUploadFont(e)));
	}
	processStaffUploadFont(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? U("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 401 ? U("No description", e.status, e.data, t) : e.status === 403 ? U("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : U("An unexpected server error occurred.", e.status, e.data, t);
	}
	updateGenericSubject(e, t) {
		let r = this.baseUrl + "/UpdateGenericSubject", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processUpdateGenericSubject(e)));
	}
	processUpdateGenericSubject(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? U("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 401 ? U("No description", e.status, e.data, t) : e.status === 404 || e.status === 409 ? U("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : U("An unexpected server error occurred.", e.status, e.data, t);
	}
}, m = /* @__PURE__ */ function(e) {
	return e.Normal = "Normal", e.Italic = "Italic", e;
}({}), h = /* @__PURE__ */ function(e) {
	return e.Percentage = "Percentage", e.FlatFee = "FlatFee", e;
}({}), g = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), _ = /* @__PURE__ */ function(e) {
	return e.SquareMetres = "SquareMetres", e.Hectares = "Hectares", e.Acres = "Acres", e;
}({}), v = /* @__PURE__ */ function(e) {
	return e.PrivateTreaty = "PrivateTreaty", e.Auction = "Auction", e;
}({}), y = /* @__PURE__ */ function(e) {
	return e.BuiltOn = "BuiltOn", e.VacantLand = "VacantLand", e;
}({}), b = /* @__PURE__ */ function(e) {
	return e.Lifestyle = "Lifestyle", e.MixedFarming = "MixedFarming", e.Farmlet = "Farmlet", e.Livestock = "Livestock", e.Other = "Other", e;
}({}), x = /* @__PURE__ */ function(e) {
	return e.Search = "Search", e.Manual = "Manual", e.AttachAsFile = "AttachAsFile", e.NotAvailable = "NotAvailable", e;
}({}), S = /* @__PURE__ */ function(e) {
	return e.Text = "Text", e.Textarea = "Textarea", e.RichText = "RichText", e.Number = "Number", e.Currency = "Currency", e.Boolean = "Boolean", e.Select = "Select", e.Color = "Color", e.Image = "Image", e.Video = "Video", e.Asset = "Asset", e.Date = "Date", e.Repeater = "Repeater", e;
}({}), C = /* @__PURE__ */ function(e) {
	return e.Normal = "Normal", e.Italic = "Italic", e;
}({}), w = /* @__PURE__ */ function(e) {
	return e.PlainText = "PlainText", e.RichText = "RichText", e;
}({}), T = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), ee = /* @__PURE__ */ function(e) {
	return e.Listing = "Listing", e.Generic = "Generic", e;
}({}), te = /* @__PURE__ */ function(e) {
	return e.Draft = "Draft", e.Shared = "Shared", e.Accepted = "Accepted", e.Superseded = "Superseded", e.Archived = "Archived", e;
}({}), E = /* @__PURE__ */ function(e) {
	return e.Ready = "Ready", e.Deferred = "Deferred", e;
}({}), D = /* @__PURE__ */ function(e) {
	return e.Intro = "Intro", e.AgentProfile = "AgentProfile", e.Appraisal = "Appraisal", e.Cma = "Cma", e.RecentSales = "RecentSales", e.PropertyGallery = "PropertyGallery", e.MarketingQuote = "MarketingQuote", e.Fees = "Fees", e.Testimonials = "Testimonials", e.CallToAction = "CallToAction", e.AttachmentPdf = "AttachmentPdf", e.Freeform = "Freeform", e.CustomHtml = "CustomHtml", e.List = "List", e.PropertyOverview = "PropertyOverview", e.MarketingCalendar = "MarketingCalendar", e.MethodOfSale = "MethodOfSale", e.MarketSnapshot = "MarketSnapshot", e.PerformanceStats = "PerformanceStats", e.CaseStudy = "CaseStudy", e.Media = "Media", e;
}({}), O = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), k = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), A = /* @__PURE__ */ function(e) {
	return e.Campaign = "Campaign", e.Standalone = "Standalone", e;
}({}), j = /* @__PURE__ */ function(e) {
	return e.Compact = "Compact", e.Comfortable = "Comfortable", e.Editorial = "Editorial", e;
}({}), M = /* @__PURE__ */ function(e) {
	return e.Standard = "Standard", e.Wide = "Wide", e;
}({}), N = /* @__PURE__ */ function(e) {
	return e.Platform = "Platform", e.Agency = "Agency", e;
}({}), P = /* @__PURE__ */ function(e) {
	return e.Platform = "Platform", e.Agency = "Agency", e.PrivateAgent = "PrivateAgent", e;
}({}), F = /* @__PURE__ */ function(e) {
	return e.Normal = "Normal", e.Italic = "Italic", e;
}({}), I = /* @__PURE__ */ function(e) {
	return e.Draft = "Draft", e.Published = "Published", e.Archived = "Archived", e;
}({}), L = /* @__PURE__ */ function(e) {
	return e.Campaign = "Campaign", e.Standalone = "Standalone", e;
}({}), R = /* @__PURE__ */ function(e) {
	return e.Active = "Active", e.Archived = "Archived", e;
}({}), z = /* @__PURE__ */ function(e) {
	return e.SingleRate = "SingleRate", e.MultiRate = "MultiRate", e;
}({}), B = /* @__PURE__ */ function(e) {
	return e.Miscellaneous = "Miscellaneous", e.AgencyAgreement = "AgencyAgreement", e.MarketingAgreement = "MarketingAgreement", e.TitleSearch = "TitleSearch", e.BodyCorporateDisclosureStatement = "BodyCorporateDisclosureStatement", e.PoolCertificate = "PoolCertificate", e.NoticeOfMultipleOffers = "NoticeOfMultipleOffers", e.NoPoolCertificate = "NoPoolCertificate", e.AppointmentOfRealEstateAgent = "AppointmentOfRealEstateAgent", e.IntentToSell = "IntentToSell", e.SignedContract = "SignedContract", e.PowerOfAttorney = "PowerOfAttorney", e.WaiverOfCoolingOff = "WaiverOfCoolingOff", e.SalesContract = "SalesContract", e.SalesContractAnnexure = "SalesContractAnnexure", e.MergedAgencyAgreement = "MergedAgencyAgreement", e.MergedSalesContract = "MergedSalesContract", e.MaterialFact = "MaterialFact", e.ProofOfIdentity = "ProofOfIdentity", e.BlankSalesContract = "BlankSalesContract", e.AgencyAgreementAnnexure = "AgencyAgreementAnnexure", e.ConsumerGuide = "ConsumerGuide", e.OwnerBuilderDeclaration = "OwnerBuilderDeclaration", e.BlankSalesContractFlattened = "BlankSalesContractFlattened", e.AdditionalAnnexure = "AdditionalAnnexure", e.SalesAdvice = "SalesAdvice", e.ComparativeMarketAnalysis = "ComparativeMarketAnalysis", e.BuildingCertificate = "BuildingCertificate", e.SurveyPlan = "SurveyPlan", e.SellerDisclosure = "SellerDisclosure", e.BodyCorporateCertificate = "BodyCorporateCertificate", e.CommunityManagementStatement = "CommunityManagementStatement", e.DisclosureInstructions = "DisclosureInstructions", e.ListingPropertyImage = "ListingPropertyImage", e.ListingFloorPlan = "ListingFloorPlan", e.ExchangeLetter = "ExchangeLetter", e.VendorSettlementConfirmation = "VendorSettlementConfirmation", e.BuyerSettlementConfirmation = "BuyerSettlementConfirmation", e.PexaSettlementConfirmation = "PexaSettlementConfirmation", e.BuyerSolicitorEarlyDeposit = "BuyerSolicitorEarlyDeposit", e.VendorSolicitorEarlyDeposit = "VendorSolicitorEarlyDeposit", e.VendorTerminationConfirmation = "VendorTerminationConfirmation", e.BuyerTerminationConfirmation = "BuyerTerminationConfirmation", e.ContractExchange = "ContractExchange", e.WithdrawalConfirmation = "WithdrawalConfirmation", e.ProposalAttachment = "ProposalAttachment", e.ProposalAgencyFont = "ProposalAgencyFont", e.AdditionalSettlementCorrespondence = "AdditionalSettlementCorrespondence", e.AuthorityToExchange = "AuthorityToExchange", e.MergedContractExchange = "MergedContractExchange", e;
}({}), V = /* @__PURE__ */ function(e) {
	return e.Dollar = "Dollar", e.Percentage = "Percentage", e;
}({}), H = class extends Error {
	message;
	status;
	response;
	headers;
	result;
	constructor(e, t, n, r, i) {
		super(), this.message = e, this.status = t, this.response = n, this.headers = r, this.result = i;
	}
	isProposalsApiException = !0;
	static isProposalsApiException(e) {
		return e.isProposalsApiException === !0;
	}
};
function U(e, t, n, r, i) {
	throw i ?? new H(e, t, n, r, null);
}
//#endregion
//#region src/useClientContext.tsx
var W = "proposals";
function G(e) {
	let t = Object.getPrototypeOf(e);
	for (let n of Object.getOwnPropertyNames(t)) {
		let r = t[n];
		typeof r == "function" && n !== "constructor" && (e[n] = r.bind(e));
	}
	return e;
}
var K = (e, t, n) => {
	let r = new p(e);
	return r.setAuthConfig(t, n), G(r);
}, q = ({ baseApiUri: e, localUris: t }) => {
	if (!e) throw console.error("Base API URI is undefined"), Error("Base API URI is undefined");
	return t?.[W] || `${e}/${W}`;
}, J = (t) => {
	let n = r(10), { agxConfig: i } = t, { getAuthToken: a } = o(e), l, u, d;
	n[0] !== i || n[1] !== a ? (l = q(i), u = c, d = K(l, a, i), n[0] = i, n[1] = a, n[2] = l, n[3] = u, n[4] = d) : (l = n[2], u = n[3], d = n[4]);
	let [f, p] = u(d), m, h;
	return n[5] !== i || n[6] !== l || n[7] !== a ? (m = () => {
		let e = K(l, a, i);
		p(e);
	}, h = [
		a,
		i,
		l
	], n[5] = i, n[6] = l, n[7] = a, n[8] = m, n[9] = h) : (m = n[8], h = n[9]), s(m, h), f;
}, Y = a({}), X = (e) => {
	let t = r(5), { appConfig: n, children: a } = e, o;
	t[0] === n ? o = t[1] : (o = { agxConfig: n }, t[0] = n, t[1] = o);
	let s = J(o);
	if (!s) return null;
	let c;
	return t[2] !== s || t[3] !== a ? (c = /* @__PURE__ */ i(Y.Provider, {
		value: s,
		children: a
	}), t[2] = s, t[3] = a, t[4] = c) : c = t[4], c;
}, Z = (e) => {
	let t = r(12), n = e === void 0 || e, i = o(Y), a;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (a = ["agentListFontResources"], t[0] = a) : a = t[0];
	let s;
	t[1] === i ? s = t[2] : (s = (e) => {
		let { signal: t } = e;
		return i.agentListFontResources(t);
	}, t[1] = i, t[2] = s);
	let c = n && !!i, l;
	t[3] !== s || t[4] !== c ? (l = {
		queryKey: a,
		queryFn: s,
		enabled: c
	}, t[3] = s, t[4] = c, t[5] = l) : l = t[5];
	let { data: d, isPending: f, isError: p, error: m, isFetching: h } = u(l), g;
	return t[6] !== d || t[7] !== m || t[8] !== p || t[9] !== h || t[10] !== f ? (g = {
		data: d,
		isPending: f,
		isError: p,
		error: m,
		isFetching: h
	}, t[6] = d, t[7] = m, t[8] = p, t[9] = h, t[10] = f, t[11] = g) : g = t[11], g;
}, Q = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (...e) => {
		let n = e;
		for (; n.length > 0 && n[n.length - 1] === void 0;) n.pop();
		await t.invalidateQueries({ queryKey: ["agentListFontResources", ...n] });
	}, e[0] = t, e[1] = n), n;
}, ne = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(Y), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.archiveProposal(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		archiveProposal: d,
		archiveProposalPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, re = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(Y), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.createPrivateSectionTemplate(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		createPrivateSectionTemplate: d,
		createPrivateSectionTemplatePending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, ie = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(Y), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.createProposal(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		createProposal: d,
		createProposalPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, ae = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(Y), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.deleteProposal(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		deleteProposal: d,
		deleteProposalPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, oe = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(Y), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.duplicateProposal(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		duplicateProposal: d,
		duplicateProposalPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, se = (e, t) => {
	let n = r(15), i = t === void 0 || t, a = o(Y), s;
	n[0] === e ? s = n[1] : (s = ["getProposal", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.getProposal(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h, error: g, isFetching: _ } = u(f), v;
	return n[9] !== p || n[10] !== g || n[11] !== h || n[12] !== _ || n[13] !== m ? (v = {
		data: p,
		isPending: m,
		isError: h,
		error: g,
		isFetching: _
	}, n[9] = p, n[10] = g, n[11] = h, n[12] = _, n[13] = m, n[14] = v) : v = n[14], v;
}, ce = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (...e) => {
		let n = e;
		for (; n.length > 0 && n[n.length - 1] === void 0;) n.pop();
		await t.invalidateQueries({ queryKey: ["getProposal", ...n] });
	}, e[0] = t, e[1] = n), n;
}, $ = (e, t) => {
	let n = r(15), i = t === void 0 || t, a = o(Y), s;
	n[0] === e ? s = n[1] : (s = ["getRenderContext", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.getRenderContext(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h, error: g, isFetching: _ } = u(f), v;
	return n[9] !== p || n[10] !== g || n[11] !== h || n[12] !== _ || n[13] !== m ? (v = {
		data: p,
		isPending: m,
		isError: h,
		error: g,
		isFetching: _
	}, n[9] = p, n[10] = g, n[11] = h, n[12] = _, n[13] = m, n[14] = v) : v = n[14], v;
}, le = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (...e) => {
		let n = e;
		for (; n.length > 0 && n[n.length - 1] === void 0;) n.pop();
		await t.invalidateQueries({ queryKey: ["getRenderContext", ...n] });
	}, e[0] = t, e[1] = n), n;
}, ue = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(Y), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.insertPublishedSectionTemplate(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		insertPublishedSectionTemplate: d,
		insertPublishedSectionTemplatePending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, de = (e, t, n) => {
	let i = r(17), a = n === void 0 || n, s = o(Y), c;
	i[0] !== e || i[1] !== t ? (c = [
		"listProposals",
		e,
		t
	], i[0] = e, i[1] = t, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== e || i[4] !== s || i[5] !== t ? (d = (n) => {
		let { signal: r } = n;
		return s.listProposals(e, t, r);
	}, i[3] = e, i[4] = s, i[5] = t, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g, error: _, isFetching: v } = u(p), y;
	return i[11] !== m || i[12] !== _ || i[13] !== g || i[14] !== v || i[15] !== h ? (y = {
		data: m,
		isPending: h,
		isError: g,
		error: _,
		isFetching: v
	}, i[11] = m, i[12] = _, i[13] = g, i[14] = v, i[15] = h, i[16] = y) : y = i[16], y;
}, fe = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (...e) => {
		let n = e;
		for (; n.length > 0 && n[n.length - 1] === void 0;) n.pop();
		await t.invalidateQueries({ queryKey: ["listProposals", ...n] });
	}, e[0] = t, e[1] = n), n;
}, pe = (e, t, n, i) => {
	let a = r(19), s = i === void 0 || i, c = o(Y), l;
	a[0] !== t || a[1] !== n || a[2] !== e ? (l = [
		"listPublishedProposalTemplates",
		e,
		t,
		n
	], a[0] = t, a[1] = n, a[2] = e, a[3] = l) : l = a[3];
	let d = l, f;
	a[4] !== c || a[5] !== t || a[6] !== n || a[7] !== e ? (f = (r) => {
		let { signal: i } = r;
		return c.listPublishedProposalTemplates(e, t, n, i);
	}, a[4] = c, a[5] = t, a[6] = n, a[7] = e, a[8] = f) : f = a[8];
	let p = s && !!c, m;
	a[9] !== d || a[10] !== f || a[11] !== p ? (m = {
		queryKey: d,
		queryFn: f,
		enabled: p
	}, a[9] = d, a[10] = f, a[11] = p, a[12] = m) : m = a[12];
	let { data: h, isPending: g, isError: _, error: v, isFetching: y } = u(m), b;
	return a[13] !== h || a[14] !== v || a[15] !== _ || a[16] !== y || a[17] !== g ? (b = {
		data: h,
		isPending: g,
		isError: _,
		error: v,
		isFetching: y
	}, a[13] = h, a[14] = v, a[15] = _, a[16] = y, a[17] = g, a[18] = b) : b = a[18], b;
}, me = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (...e) => {
		let n = e;
		for (; n.length > 0 && n[n.length - 1] === void 0;) n.pop();
		await t.invalidateQueries({ queryKey: ["listPublishedProposalTemplates", ...n] });
	}, e[0] = t, e[1] = n), n;
}, he = (e, t, n, i, a) => {
	let s = r(21), c = a === void 0 || a, l = o(Y), d;
	s[0] !== n || s[1] !== i || s[2] !== t || s[3] !== e ? (d = [
		"listSectionTemplates",
		e,
		t,
		n,
		i
	], s[0] = n, s[1] = i, s[2] = t, s[3] = e, s[4] = d) : d = s[4];
	let f = d, p;
	s[5] !== n || s[6] !== l || s[7] !== i || s[8] !== t || s[9] !== e ? (p = (r) => {
		let { signal: a } = r;
		return l.listSectionTemplates(e, t, n, i, a);
	}, s[5] = n, s[6] = l, s[7] = i, s[8] = t, s[9] = e, s[10] = p) : p = s[10];
	let m = c && !!l, h;
	s[11] !== f || s[12] !== p || s[13] !== m ? (h = {
		queryKey: f,
		queryFn: p,
		enabled: m
	}, s[11] = f, s[12] = p, s[13] = m, s[14] = h) : h = s[14];
	let { data: g, isPending: _, isError: v, error: y, isFetching: b } = u(h), x;
	return s[15] !== g || s[16] !== y || s[17] !== v || s[18] !== b || s[19] !== _ ? (x = {
		data: g,
		isPending: _,
		isError: v,
		error: y,
		isFetching: b
	}, s[15] = g, s[16] = y, s[17] = v, s[18] = b, s[19] = _, s[20] = x) : x = s[20], x;
}, ge = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (...e) => {
		let n = e;
		for (; n.length > 0 && n[n.length - 1] === void 0;) n.pop();
		await t.invalidateQueries({ queryKey: ["listSectionTemplates", ...n] });
	}, e[0] = t, e[1] = n), n;
}, _e = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(Y), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.saveProposal(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		saveProposal: d,
		saveProposalPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, ve = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(Y), c;
	t[2] === s ? c = t[3] : (c = async (e) => {
		let { templateId: t, body: n } = e;
		return s.staffArchiveProposalTemplate(t, n);
	}, t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		staffArchiveProposalTemplate: d,
		staffArchiveProposalTemplatePending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, ye = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(Y), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.staffArchiveSectionTemplate(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		staffArchiveSectionTemplate: d,
		staffArchiveSectionTemplatePending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, be = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(Y), c;
	t[2] === s ? c = t[3] : (c = async (e) => {
		let { id: t, body: n } = e;
		return s.staffArchiveThemeSet(t, n);
	}, t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		staffArchiveThemeSet: d,
		staffArchiveThemeSetPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, xe = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(Y), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.staffCreateProposalTemplate(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		staffCreateProposalTemplate: d,
		staffCreateProposalTemplatePending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, Se = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(Y), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.staffCreateSectionTemplate(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		staffCreateSectionTemplate: d,
		staffCreateSectionTemplatePending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, Ce = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(Y), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.staffCreateThemeSet(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		staffCreateThemeSet: d,
		staffCreateThemeSetPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, we = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(Y), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.staffDuplicateProposalTemplate(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		staffDuplicateProposalTemplate: d,
		staffDuplicateProposalTemplatePending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, Te = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(Y), c;
	t[2] === s ? c = t[3] : (c = async (e) => {
		let { id: t, body: n } = e;
		return s.staffDuplicateThemeSet(t, n);
	}, t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		staffDuplicateThemeSet: d,
		staffDuplicateThemeSetPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, Ee = (e, t) => {
	let n = r(15), i = t === void 0 || t, a = o(Y), s;
	n[0] === e ? s = n[1] : (s = ["staffListFonts", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.staffListFonts(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h, error: g, isFetching: _ } = u(f), v;
	return n[9] !== p || n[10] !== g || n[11] !== h || n[12] !== _ || n[13] !== m ? (v = {
		data: p,
		isPending: m,
		isError: h,
		error: g,
		isFetching: _
	}, n[9] = p, n[10] = g, n[11] = h, n[12] = _, n[13] = m, n[14] = v) : v = n[14], v;
}, De = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (...e) => {
		let n = e;
		for (; n.length > 0 && n[n.length - 1] === void 0;) n.pop();
		await t.invalidateQueries({ queryKey: ["staffListFonts", ...n] });
	}, e[0] = t, e[1] = n), n;
}, Oe = (e, t, n, i) => {
	let a = r(19), s = i === void 0 || i, c = o(Y), l;
	a[0] !== t || a[1] !== n || a[2] !== e ? (l = [
		"staffListProposalTemplates",
		e,
		t,
		n
	], a[0] = t, a[1] = n, a[2] = e, a[3] = l) : l = a[3];
	let d = l, f;
	a[4] !== t || a[5] !== c || a[6] !== n || a[7] !== e ? (f = (r) => {
		let { signal: i } = r;
		return c.staffListProposalTemplates(e, t, n, i);
	}, a[4] = t, a[5] = c, a[6] = n, a[7] = e, a[8] = f) : f = a[8];
	let p = s && !!c, m;
	a[9] !== d || a[10] !== f || a[11] !== p ? (m = {
		queryKey: d,
		queryFn: f,
		enabled: p
	}, a[9] = d, a[10] = f, a[11] = p, a[12] = m) : m = a[12];
	let { data: h, isPending: g, isError: _, error: v, isFetching: y } = u(m), b;
	return a[13] !== h || a[14] !== v || a[15] !== _ || a[16] !== y || a[17] !== g ? (b = {
		data: h,
		isPending: g,
		isError: _,
		error: v,
		isFetching: y
	}, a[13] = h, a[14] = v, a[15] = _, a[16] = y, a[17] = g, a[18] = b) : b = a[18], b;
}, ke = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (...e) => {
		let n = e;
		for (; n.length > 0 && n[n.length - 1] === void 0;) n.pop();
		await t.invalidateQueries({ queryKey: ["staffListProposalTemplates", ...n] });
	}, e[0] = t, e[1] = n), n;
}, Ae = (e, t, n) => {
	let i = r(17), a = n === void 0 || n, s = o(Y), c;
	i[0] !== t || i[1] !== e ? (c = [
		"staffListThemeSets",
		e,
		t
	], i[0] = t, i[1] = e, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== t || i[4] !== s || i[5] !== e ? (d = (n) => {
		let { signal: r } = n;
		return s.staffListThemeSets(e, t, r);
	}, i[3] = t, i[4] = s, i[5] = e, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g, error: _, isFetching: v } = u(p), y;
	return i[11] !== m || i[12] !== _ || i[13] !== g || i[14] !== v || i[15] !== h ? (y = {
		data: m,
		isPending: h,
		isError: g,
		error: _,
		isFetching: v
	}, i[11] = m, i[12] = _, i[13] = g, i[14] = v, i[15] = h, i[16] = y) : y = i[16], y;
}, je = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (...e) => {
		let n = e;
		for (; n.length > 0 && n[n.length - 1] === void 0;) n.pop();
		await t.invalidateQueries({ queryKey: ["staffListThemeSets", ...n] });
	}, e[0] = t, e[1] = n), n;
}, Me = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(Y), c;
	t[2] === s ? c = t[3] : (c = async (e) => {
		let { templateId: t, body: n } = e;
		return s.staffPublishProposalTemplate(t, n);
	}, t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		staffPublishProposalTemplate: d,
		staffPublishProposalTemplatePending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, Ne = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(Y), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.staffPublishSectionTemplate(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		staffPublishSectionTemplate: d,
		staffPublishSectionTemplatePending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, Pe = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(Y), c;
	t[2] === s ? c = t[3] : (c = async (e) => {
		let { templateId: t, body: n } = e;
		return s.staffUpdateProposalTemplate(t, n);
	}, t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		staffUpdateProposalTemplate: d,
		staffUpdateProposalTemplatePending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, Fe = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(Y), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.staffUpdateSectionTemplate(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		staffUpdateSectionTemplate: d,
		staffUpdateSectionTemplatePending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, Ie = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(Y), c;
	t[2] === s ? c = t[3] : (c = async (e) => {
		let { id: t, body: n } = e;
		return s.staffUpdateThemeSet(t, n);
	}, t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		staffUpdateThemeSet: d,
		staffUpdateThemeSetPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, Le = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(Y), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.staffUploadFont(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		staffUploadFont: d,
		staffUploadFontPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, Re = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(Y), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.updateGenericSubject(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		updateGenericSubject: d,
		updateGenericSubjectPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
};
//#endregion
export { m as AgencyFontStyle, h as FlatCommissionType, g as GenericSubjectUpdateRequestJurisdiction, _ as LandAreaDetailsTotalLandAreaType, v as ListingSaleDetailsSaleType, y as PropertyDetailsBuiltOnOrVacantLandType, b as PropertyDetailsRuralType, x as ProposalCmaValuesComparativeType, S as ProposalFieldDefinitionType, C as ProposalFontResourceStyle, w as ProposalInlineEditingMode, T as ProposalPropertyValuesJurisdiction, ee as ProposalResponseProposalType, te as ProposalResponseStatus, E as ProposalSectionAvailabilityStatus, D as ProposalSectionType, O as ProposalSubjectJurisdiction, k as ProposalSubjectRequestJurisdiction, A as ProposalSubjectRequestType, j as ProposalThemeLayoutDensity, M as ProposalThemeLayoutPageWidth, Y as ProposalsApiContext, H as ProposalsApiException, X as ProposalsApiProvider, p as ProposalsClient, W as ProposalsRoute, N as PublishedProposalTemplateResponseScope, P as Scope, F as StaffUploadFontFormStyle, I as Status, L as SubjectType, R as ThemeSetResponseStatus, z as TieredCommissionTieredSystemType, B as UploadedDocumentDocumentType, V as VendorChoiceValueType, Z as useAgentListFontResources, ne as useArchiveProposal, re as useCreatePrivateSectionTemplate, ie as useCreateProposal, ae as useDeleteProposal, oe as useDuplicateProposal, se as useGetProposal, $ as useGetRenderContext, ue as useInsertPublishedSectionTemplate, Q as useInvalidateUseAgentListFontResources, ce as useInvalidateUseGetProposal, le as useInvalidateUseGetRenderContext, fe as useInvalidateUseListProposals, me as useInvalidateUseListPublishedProposalTemplates, ge as useInvalidateUseListSectionTemplates, De as useInvalidateUseStaffListFonts, ke as useInvalidateUseStaffListProposalTemplates, je as useInvalidateUseStaffListThemeSets, de as useListProposals, pe as useListPublishedProposalTemplates, he as useListSectionTemplates, J as useProposalsClientContext, _e as useSaveProposal, ve as useStaffArchiveProposalTemplate, ye as useStaffArchiveSectionTemplate, be as useStaffArchiveThemeSet, xe as useStaffCreateProposalTemplate, Se as useStaffCreateSectionTemplate, Ce as useStaffCreateThemeSet, we as useStaffDuplicateProposalTemplate, Te as useStaffDuplicateThemeSet, Ee as useStaffListFonts, Oe as useStaffListProposalTemplates, Ae as useStaffListThemeSets, Me as useStaffPublishProposalTemplate, Ne as useStaffPublishSectionTemplate, Pe as useStaffUpdateProposalTemplate, Fe as useStaffUpdateSectionTemplate, Ie as useStaffUpdateThemeSet, Le as useStaffUploadFont, Re as useUpdateGenericSubject };
